<template>
    <span>
        <div class="modal fade popup-offer" id="offer-exit-pop" tabindex="-1">
            <div class="modal-dialog modal-lg single-offer operator-list" role="document" style="margin-top: 100px">
                <div class="modal-content">
                    <div class="modal-body single-offer-item single-offer-operator-item">
                        <button type="button" data-dismiss="modal" aria-label="Close" class="button-close close_popup">
                            <svg viewBox="0 0 384 512" class="close-popup-cta"><path
                                d="M231.6 256l130.1-130.1c4.7-4.7 4.7-12.3 0-17l-22.6-22.6c-4.7-4.7-12.3-4.7-17 0L192 216.4 61.9 86.3c-4.7-4.7-12.3-4.7-17 0l-22.6 22.6c-4.7 4.7-4.7 12.3 0 17L152.4 256 22.3 386.1c-4.7 4.7-4.7 12.3 0 17l22.6 22.6c4.7 4.7 12.3 4.7 17 0L192 295.6l130.1 130.1c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17L231.6 256z"
                                style="color:  black;"></path></svg>
                        </button>
                        <div class="modal-header-content">
                            <a class="automation-play-now-cta exit_pop_offer_cta exit-page-link operator-item-link"
                               rel="nofollow"
                               target="_blank"
                               :href="offer.exit_link | appendfragment(ct, ctalocation, listId || '_', '_', rankVersion || '_', listPosition, '_')"
                               :data-gtm="gtm.replace('LOCATION', 'logo')"
                               data-kt="cta:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
                               data-ctalocation="image"
                               :data-operator="offer.brand_name"
                               :data-product="offer.brand_product_name"
                               :data-offer="offer.offer_short_description | striptags"
                               :data-brand_id="offer.brand_id"
                               :data-brand_product_id="offer.brand_product_id"
                               :data-offer_id="offer.offer_id"
                               :data-site_offer_id="offer.site_offer_id"
                            >
                            <div class="popup-logo">
                                <img
                                    class="img-fluid lazyload"
                                    :src="offer.brand_product_image"
                                    :data-src="offer.brand_product_image"
                                    :alt="offer.brand_product_name"
                                    :title="offer.brand_product_name"
                                >
                            </div>
                            </a>
                        </div>
                        <div class="popup-2nd-col">
                            <div class="operator-column operator-column-bonus popup-bonus">
                                <div class="py-0 py-md-3">
                                    <label v-if="showProductType">{{ offer.product_type }}</label>
                                    <p class="operator-bonus text-center operator-bonus-popup">
                                        <span v-html="offer.offer_short_description"></span>
                                        <span v-if="offer.promo_code"><br>Promo Code:
                                        <em v-html="offer.promo_code"></em></span>
                                    </p>
                                </div>
                            </div>
                            <div class="operator-column operator-playnow-column p-0"
                                 style="width: 100%; max-width: 300px; display: block; height: auto; float: none; margin: auto">
                                <a class="automation-play-now-cta exit_pop_offer_cta exit-page-link operator-item-link d-block"
                                   target="_blank"
                                   :href="offer.exit_link | appendfragment(ct, ctalocation, listId || '_', '_', rankVersion || '_', listPosition, '_')"
                                   :data-gtm="gtm.replace('LOCATION', 'logo')"
                                   data-kt="cta:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
                                   data-ctalocation="cta"
                                   :data-operator="offer.brand_name"
                                   :data-product="offer.brand_product_name"
                                   :data-offer="offer.offer_short_description | striptags"
                                   :data-brand_id="offer.brand_id"
                                   :data-brand_product_id="offer.brand_product_id"
                                   :data-offer_id="offer.offer_id"
                                   :data-site_offer_id="offer.site_offer_id">
                                    <span class="operator-play-now btn-cta-play-now mt-3"
                                          style="width: 100%">
                                        <span v-if="ctaText">{{ ctaText }}</span>
                                        <!-- <span v-else-if="offer.product_type == 'Betting'">{{ betNowText }}</span> -->
                                        <!-- <span v-else>{{ playNowText }}</span> -->
                                        <span v-else>{{ popupCTAText }}</span>
                                    </span>
                                </a>
                            </div>
                            <div class="continue-browsing continue_browsing_popup">
                                Continue Browsing
                            </div>
                        </div>

                        <div class="operator-item-link read-terms-link" >
                            <div class="terms-and-conditions" style="padding: 0; margin: 0 15px 15px 15px;">
                                <div
                                    class="terms-and-conditions"
                                    v-if="offer.offer_terms_conditions"
                                    v-html="offer.offer_terms_conditions"
                                ></div>
                                <div class="terms-and-conditions" v-else>
                                    <span v-if="this.ipCountry == 'CA'">
                                        19+. T&C Apply. Play Responsibly
                                    </span>
                                    <span v-else>
                                        <span v-html="getAge()"></span>+, terms apply, 1800-GAMBLER
                                    </span>
                                </div>                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    name: 'popup-offer',
    props: {
        id: {
            type: Number,
        },
        offer: {
            type: Object,
            required: true,
        },
        listPosition: {
            type: Number,
            required: false,
            default: 1,
        },
        listId: {
            type: String,
            required: false,
        },
        rankVersion: {
            type: String,
            required: false,
        },
        imgPlaceholder: {
            type: String,
            required: true,
        },
        ct: {
            type: String,
            default: 'cta'
        },
        ctaLocation: {
            type: String,
            required: true,
        },
        ctaText: {
            type: String,
            required: false,
        },
        gtm: {
            type: String,
            required: true,
        },
        selectedState: {
            type: String,
            required: true,
        },
        selectedStateName: {
            type: String,
            default: '',
            required: false,
        },
        isOntario: {
            type: Boolean,
            default: false,
            required: false,
        },
        showProductType: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    data: function () {
        return {
            ctalocation: this.ctaLocation.replaceAll(" ", "_"),
            floatingCTAClosed: false,
            idleMobileTime: 20000, // 20 sec
            idleDesktopTime: 20000,
            timeoutDesktop: false,
            idleTime: 0,
            timeoutID: null,
            intervalID: null,
            popUpCookieName: "",
            showEmail: false,
            mutableSelectedState: this.selectedState,
            ipCountry: $('html').attr('data-ipcountry') ?
                $('html').attr('data-ipcountry').toUpperCase() : false,
            regionCode: $('html').attr('data-regioncode') ?
                $('html').attr('data-regioncode').toUpperCase() : false,
        }
    },
    methods: {
        getAge() {
            return this.regionCode === 'RI' ? '18' : '21';
        },

        isTouchDevice() {
            return (('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0));
        },

        showModal() {
            if (!this.floatingCTAClosed) {
                if (!this.showEmail) {
                    $('#offer-exit-pop').modal('show');
                } else {
                    $('#popUpEmail').modal('show');
                }
                this.floatingCTAClosed = true;
            }
        },

        emailOrOffer() {
            this.floatingCTAClosed = false
            this.popUpCookieName = "offer_closed_us_" + this.offer.brand_product_id + "_" + this.selectedState
            if (getCookie(this.popUpCookieName)) {
                this.floatingCTAClosed = true;
            }

            this.mutableSelectedState = this.selectedState
            this.timeoutDesktop = false;
            setTimeout(() => this.timeoutDesktop = true, this.idleDesktopTime);
            window.clearTimeout(this.timeoutID);
            if (this.isTouchDevice()) {
                this.timeoutID = setTimeout(() => this.showModal(), this.idleMobileTime);
            }

            if ((Object.hasOwn(this.offer, 'us_states')) && (this.offer.us_states[0].code === "AB")) {
                this.mutableSelectedState = "AB";
            }

            if (!Object.hasOwn(this.offer, 'us_states') || (this.offer.us_states[0].code != this.mutableSelectedState) || (this.isOntario)) {
                this.showEmail = true;
                if (this.isOntario) {
                    $('#email-form-region-name').html("Ontario")
                } else {
                    $('#email-form-region-name').html(this.selectedStateName)
                }
            } else {
                this.showEmail = false;
            }
        },

        resetPopUpTimeout() {
            window.clearTimeout(this.timeoutID);
            this.timeoutID = setTimeout(() => this.showModal(), this.idleMobileTime);
        }
    },
    computed: {
        // betNowText() {
        //     return window.translations.oplist.cta_bet_now || 'BET NOW';
        // },
        // playNowText() {
        //     return window.translations.oplist.cta_play_now || 'PLAY NOW';
        // },
        popupCTAText() {
            return window.translations.popupCTA.cta_popup_text || 'VISIT CASINO';
        }
    },

    watch: {
        selectedState() {
            return this.emailOrOffer()
        },
        offer() {
            return this.emailOrOffer()
        },
    },

    mounted: function () {

        this.emailOrOffer();
        $(document).on('mouseleave', () => {
            if (this.timeoutDesktop && !this.isTouchDevice()) {
                this.showModal();
            }
        });

        document.addEventListener("touchstart", () => {
            if (this.isTouchDevice()) {
                this.resetPopUpTimeout();
            }
        });

        // to catch search input events on mobile
        if (this.isTouchDevice()) {
            this.intervalID = setInterval(() => {
                if (document.getElementsByClassName("search-input")[0]) {
                    document.getElementsByClassName("search-input")[0].addEventListener('input', () => {
                        this.resetPopUpTimeout();
                    })
                }
            }, 3000);
        }

        setTimeout(() => this.timeoutDesktop = true, this.idleDesktopTime);

        $('.continue-browsing').click(() => {
            setCookie(this.popUpCookieName, true, 1);
            $('#offer-exit-pop').modal('hide');
            $('#popUpEmail').modal('hide');
        });

        $('.close_popup').click(() => {
            setCookie(this.popUpCookieName, true, 1);
        });

    }
};


</script>
